<template>
	<!-- router link -->
	<router-link :to="contentRoute" :event="content.length < 5 ? '' : 'click'" :class="(content.length < 5 ? 'reset-cursor' : '')">
		<!-- MAIN parent element with a background image that can be removed in the less file -->
		<div :class="`${view}-thumbnail-parent`" :style="backgroundImage">
			<!-- CONTAINER element that holds all the elements -->
			<div v-if="showContentDetails" :class="`${view}-thumbnail-content-container`">
				<!-- LIST background image -->
				<div v-if="['list', 'grid', 'bio'].indexOf(view) >= 0 && this.imageUrl && featureSet.thumbnail.imageSeparate[view] && content.length >= 5" :class="`${view}-thumbnail-content-image`" :style="backgroundImage"></div>
				<!-- <img v-if="['bio'].indexOf(view) >= 0" :src="imageUrl" :class="`${view}-thumbnail-tag-image`"> -->
				<!-- HEADING/TITLE -->
				<h1 :class="`${view}-thumbnail-title`">{{title}}</h1>
				<!-- DATE -->
				<span v-if="['list', 'job', 'bio'].indexOf(view) >= 0" :class="`${view}-thumbnail-date`">{{ formattedDate }}</span>
				<!-- TEXT contents of the post -->
				<div :class="`${view}-thumbnail-content`" v-if="(view === 'list' && !featureSet.thumbnail.hideTextContent) || ['job', 'bio', 'grid'].indexOf(view) >= 0">
					<!-- GRID background image -->
					<div v-if="view === 'list' && this.imageUrl && !featureSet.thumbnail.imageSeparate['list'] && content.length >= 5" :class="`${view}-thumbnail-content-image`" :style="backgroundImage"></div>
					<!-- ACTUAL text content -->
					<div :class="`${view}-thumbnail-content-text`" v-html="contentParsed" v-if="content.length >= 5"></div>
					<div v-if="view === 'list'" :class="`${view}-thumbnail-content-read-more`">{{ $store.state.readMoreText }}</div>
				</div>
				<a :class="`${view}-thumbnail-link`" :href="link_url">{{ link_text }}</a>
			</div>
		</div>
	</router-link>
</template>

<script>
import moment from 'moment';
import propIdMixin from '@/views/prop-id-mixin';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import * as parserRegexes from '@/views/content-parser-regexes';

export default {
	name: 'ContentThumbnail',
	mixins: [propIdMixin, staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	props: {
		title: String,
		content: String,
		image: [String, Number],
		type: String,
		view: String,
		date: String,
		link_text: String,
		link_url: String,
	},
	computed: {
		imageUrl() {
			if (this.image) {
				const media = this.findInMedia(Number(this.image));
				if (media && media.original_name) {
					return `/storage/media/${media.original_name}`;
				}
			}

			return false;
		},
		contentRoute() {
			if (this.type === 'post') {
				return `/posts/post/${this.id}`;
			}

			return 'invalid';
		},
		showContentDetails() {
			if (this.type === 'post') {
				return true;
			}

			return false;
		},
		backgroundImage() {
			return `background-image: url("${this.imageUrl}")`;
		},
		formattedDate() {
			if (this.date) {
				let langCode = '';
				this.languageList.forEach((lang) => {
					if (lang.name === this.language) {
						langCode = lang.code;
					}
				});
				return moment.utc(this.date).local().locale(langCode).format('ll');
			}
			return '';
		},
		contentParsed() {
			let newContent = this.content;
			Object.keys(parserRegexes).forEach((pName) => {
				newContent = newContent.replace(parserRegexes[pName], '');
			});
			newContent = `${newContent}<div class="thumbnail-text-overlay"></div>`;
			return newContent;
		},
	},
};
</script>

<style src="@/styles/components/ContentThumbnail/ContentThumbnail.less" lang="less" scoped></style>
